export const enum ImageSizes {
  //Mostly not available, only before processing
  ORIGINAL = "",
  //available after resizing - 3 seconds after upload
  Thumb = "_256x256", //144p
  SD = "_720x720", //480P
  HD = "_1280x1280", //720p
  Full_hd = "_1920x1920", //1080p
  Ultra_hd = "_3840x3840", //4k
}
